const maskString = (value: string, mask?: string) => {
  if (!mask) return value;

  const result = [...mask].reduce((prev, curr) => {
    if (curr.toLowerCase() === 'x') {
      prev = prev + value.charAt(0) || '';
      value = value.slice(1);
    } else prev += curr;
    return prev;
  }, '');

  return result.trim();
};

export default maskString;
